import { DisplayedFile } from './filesStore';

export function buildPreviewFetchKey(
  file: Pick<DisplayedFile, 'localId' | 'loading' | 'signedRequest'>
): string {
  return [
    file.localId,
    file.loading,
    file.signedRequest?.signedRequest,
    file.signedRequest?.imageSignedRequest,
    file.signedRequest?.mergedSignedRequest,
    file.signedRequest?.mergedThumbnailSignedRequest,
  ].join('|');
}
